





































































































import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRefs
} from '@nuxtjs/composition-api'
import { AuditPackage } from '~/models/audit/package'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import AuditPackageOptionsList from '~/components/shared/classified/audits/AuditPackageOptionsList.vue'
import { capitalizeSentences } from '~/utils/string'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import AuditProviderTerms, {
  PROVIDERS_WITH_TERMS
} from '~/components/shared/classified/audits/terms/AuditProviderTerms.vue'
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons'
import AuditPackagePerks from '~/components/shared/classified/audits/AuditPackagePerks.vue'

export default defineComponent({
  components: {
    AuditProviderTerms,
    CConfirmationModal,
    AuditPackageOptionsList,
    AuditPackagePerks,
    CPrice
  },
  props: {
    package: {
      type: Object as PropType<AuditPackage>,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    selectedProviderId: {
      type: Number,
      required: true
    },
    requiresAcceptance: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const { selectedProviderId } = toRefs(props)
    const termsAccepted = ref(false)
    const showTermsModal = ref(false)
    const showProviderTerms = computed(() =>
      PROVIDERS_WITH_TERMS.includes(selectedProviderId.value)
    )
    return {
      capitalizeSentences,
      showProviderTerms,
      termsAccepted,
      showTermsModal,
      faShieldAlt
    }
  }
})
